import { db, storage } from "./config"
import { collection, addDoc, getDocs, query, where, doc, updateDoc, getDoc, deleteDoc } from "firebase/firestore"
import { getDownloadURL, ref, uploadBytes } from "firebase/storage"

export const createCondition = async (label, value) => {
    try {
        // Reference to the "conditions" collection
        const conditionsRef = collection(db, "conditions")

        // Add a new document with a generated ID
        const docRef = await addDoc(conditionsRef, {
            label: label,
            value: value,
            created_at: new Date(),
            state: 'active'
        })

        console.log("Document written with ID: ", docRef.id)
    } catch (e) {
        console.error("Error adding document: ", e)
    }
}

export const updateCondition = async (updatedData) => {
    try {
        // Reference to the specific condition document
        const conditionRef = doc(db, "conditions", updatedData.id)
        const conditionSnapshot = await getDoc(conditionRef)
        const conditionData = conditionSnapshot.data()

        const newData = {
            label: updatedData.label,
            value: updatedData.value,
            state: updatedData.state ? updatedData.state : conditionData.state
        }

        // Update the document with new data
        await updateDoc(conditionRef, newData)

        console.log("Document updated with ID: ", updatedData.id)
    } catch (e) {
        console.error("Error updating document: ", e)
    }
}

export const deleteCondition = async (conditionId) => {
    try {
        // Reference to the specific condition document
        const conditionRef = doc(db, "conditions", conditionId);

        // Delete the document
        await deleteDoc(conditionRef);

        console.log("Document deleted with ID: ", conditionId);
    } catch (e) {
        console.error("Error deleting document: ", e);
    }
}

export const getAllConditions = async (states = ["active"]) => {
    try {
        // Reference to the "conditions" collection
        const conditionsRef = collection(db, "conditions")

        const conditions = []

        // Create a query to filter conditions by state
        for (let state of states) {
            const q = query(conditionsRef, where("state", "==", state))
            const querySnapshot = await getDocs(q)
            querySnapshot.forEach(async (doc) => {
                conditions.push({ id: doc.id, ...doc.data() })
            })
        }

        // Sort by created_at in descending order (newest first)
        conditions.sort((a, b) => {
            const dateA = a.created_at && a.created_at.seconds ? new Date(a.created_at.seconds * 1000) : new Date(0)
            const dateB = b.created_at && b.created_at.seconds ? new Date(b.created_at.seconds * 1000) : new Date(0)
            return dateB - dateA
        })

        return conditions // Return the sorted array of conditions
    } catch (e) {
        console.error("Error getting documents: ", e)
        return [] // Return an empty array in case of error
    }
}

export const getConditionById = async (conditionId) => {
    try {
        // Reference to the "conditions" collection
        const conditionRef = doc(db, "conditions", conditionId)
        const querySnapshot = await getDoc(conditionRef)

        return querySnapshot.data()
    } catch (e) {
        console.error("Error getting condition: ", e)
        return null // Return null in case of error
    }
}

export const checkConditionExists = async (conditionLabel) => {
    try {
        const conditionsRef = collection(db, "conditions")
        const q = query(conditionsRef, where("label", "==", conditionLabel))
        const querySnapshot = await getDocs(q)

        if (!querySnapshot.empty) {
            return true // Condition exists
        } else {
            return false // Condition does not exist
        }
    } catch (error) {
        console.error("Error checking condition:", error)
    }
} 